import { render, staticRenderFns } from "./SearchToggle.vue?vue&type=template&id=255c6974&"
import script from "./SearchToggle.vue?vue&type=script&lang=js&"
export * from "./SearchToggle.vue?vue&type=script&lang=js&"
import style0 from "./SearchToggle.vue?vue&type=style&index=0&id=255c6974&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports